import { useState, useRef, forwardRef, useImperativeHandle, useEffect } from 'react';
import { Container, Col, Row, Form, Modal, Toast} from 'react-bootstrap';
import { Box, Stack, Typography, Button } from '@mui/material';
import _ from 'lodash';
import useToken from '../../../Components/useToken';
import * as CustomerApi from '../../../Services/CustomerApi';
import moment from 'moment';
import {siteTheme} from '../../../Components/SiteTheme';

async function getLedger(customerId, token) {
    return await CustomerApi.getCustomerLoyaltyLedger(customerId, token);
}

const defaultCurrency = 'AUD';

const Ledger = ({ customer, loyaltyPointsUpdated, loyaltyBalance }) => {
    const pointsFormRef = useRef();
    const token = useToken();

    const [currency, setCurrency] = useState(defaultCurrency);
    const [showPointsEditor, setShowPointsEditor] = useState(false);
    const [ledgerData, setLedgerData] = useState([]);
    const [pointTypeFilter, setPointTypeFilter] = useState();
    const [step, setStep] = useState(1);
    const [adjustmentRecord, setAdjustmentRecord] = useState({})
    const [showError, setShowError] = useState(false);
    const [adjustSuccess, setAdjustSuccess] = useState(false);

    useEffect(() => {
        setLedgerData(customer.loyaltyLedger);
    }, [customer])

    function showPointsAdjustment() {
        setShowError(false);
        setShowPointsEditor(true);
    }

    function pointsUpdated() {
        setShowPointsEditor(false);
    }

    function closePointsEditor() {
        setShowPointsEditor(false);
        setStep(1);
    }

    function savePointAdjustment() {
        const record = pointsFormRef.current.getAdjustmentRecord();
        if (!(record.adjustmentType && record.points && record.currencyCode && record.notes)) {
            setShowError(true)
            return
        }


        if (adjustmentRecord.adjustmentType === 'ADJUST_ADD' && !adjustmentRecord.grantedFor) {
            showError(true);
            return
        }

        if (adjustmentRecord.adjustmentType === 'ADJUST_REDEEM' && !adjustmentRecord.redemptionFor) {
            showError(true);
            return
        }


        setShowError(false);
        setAdjustmentRecord(record);
        setStep(2);
    }

    async function confirmPointAdjustment() {
        await CustomerApi.savePointsAdjustment(adjustmentRecord, token.token);
        const data = await getLedger(customer.profile.id, token.token);
        setLedgerData(data);
        setShowPointsEditor(false);
        loyaltyPointsUpdated();
        setStep(1);
        setAdjustSuccess(true);
    }

    let rowCounter = 0;

    function resetFilters() {
        setCurrency(defaultCurrency);
        setPointTypeFilter('');
    }

    // function backToEdit() {
    //     setShowError(false);
    //     setStep(1);
    // }



    return (
        <div className="Ledger Ledger--wrapper">
            <Toast autohide bg="success" show={adjustSuccess} position="top-end" onClose={() => setAdjustSuccess(false)} delay={3000}>
                <Toast.Header>
                    <img src="holder.js/20x20?text=%20" className="rounded me-2" alt="" />
                    <strong className="me-auto">Customer Update</strong>
                </Toast.Header>
                <Toast.Body>Points adjustment recorded</Toast.Body>
            </Toast>

            <Modal show={showPointsEditor} onHide={pointsUpdated} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Points Adjustment for {customer.profile.firstName + ' ' + customer.profile.lastName}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {step === 1 ? (<PointsAdjustmentForm ref={pointsFormRef} customer={customer} defaultCurrency={currency} />) : null}
                    {step === 2 ? (<ConfirmAdjustment customer={customer} adjustmentRecord={adjustmentRecord} />) : null}
                </Modal.Body>
                <Modal.Footer>
                    {showError ? (<div className="ErrorMessage">All Fields are required.</div>) : null}
                    <Button variant="secondary" onClick={closePointsEditor}>
                        Close
                    </Button>
                    {step === 1 ? (
                        <Button variant="primary" onClick={savePointAdjustment}>
                            Save Changes
                        </Button>
                    ) : null}
                    {step === 2 ? (
                        <>
                            {/* <Button variant="primary" onClick={backToEdit}>
                        Edit
                    </Button> */}
                            <Button variant="primary" onClick={confirmPointAdjustment}>
                                Confirm Adjustment
                            </Button>
                        </>
                    ) : null}
                </Modal.Footer>
            </Modal>

            <Container fluid>
            <Stack direction="horizontal" display="flex" justifyContent="end" alignItems="center" flex="1">
            <Box mt={siteTheme.spacing(8)}>
                <Button variant="contained" className="" onClick={() => showPointsAdjustment()}>Points Adjustment</Button>
                </Box>
                </Stack>

                <Box my={siteTheme.spacing(10)}>
                <Container fixed className="CustomerProfile--Container--Ledger">
                <Box className='CustomerProfile CustomerProfile--PointsdBalance'>
                <Typography variant="h2" sx={{position: 'relative', right: siteTheme.spacing(5)}} pb={siteTheme.spacing(4)}>Points Balance</Typography>
                    {loyaltyBalance.length ? 
                        loyaltyBalance.map((balance) => (
                    <Row key={balance.currencyCode} className="PointsBalance--wrapper">
                        <Col className="PointsBalance--Currency"><Typography variant="detailsDataLabel">{balance.currencyCode}</Typography></Col>
                        <Col className="PointsBalance--Amount"><Typography variant="detailsDataValue">{balance.pointsRemaining}</Typography></Col>
                    </Row>
                    )) : 
                    <Row className="PointsBalance--wrapper">
                        <Col className="PointsBalance--Amount"><Typography variant="detailsDataValue">No Points Earned</Typography></Col>
                    </Row>
                    }
                    </Box>
                    </Container>
                    </Box>
                <Row>
                    <Col xs="2">
                        <CurrencySelector currency={currency} onCurrencySelected={(val) => setCurrency(val)} />
                    </Col>
                    <Col xs="2">
                        <Form.Select value={pointTypeFilter} onChange={(e) => setPointTypeFilter(e.target.value)} style={{fontFamily: siteTheme.typography.fontFamily, fontSize: siteTheme.typography.fontSize, color: siteTheme.palette.primary, fontWeight: siteTheme.typography.fontWeightRegular}}>
                            <option value="" style={{fontFamily: siteTheme.typography.fontFamily, fontSize: siteTheme.typography.fontSize, color: siteTheme.palette.primary, fontWeight: siteTheme.typography.fontWeightRegular}}>--</option>
                            <option value="REDEMPTION" style={{fontFamily: siteTheme.typography.fontFamily, fontSize: siteTheme.typography.fontSize, color: siteTheme.palette.primary, fontWeight: siteTheme.typography.fontWeightRegular}}>REDEMPTION</option>
                            <option value="MANUAL" style={{fontFamily: siteTheme.typography.fontFamily, fontSize: siteTheme.typography.fontSize, color: siteTheme.palette.primary, fontWeight: siteTheme.typography.fontWeightRegular}}>MANUAL</option>
                        </Form.Select>
                    </Col>
                    <Col xs="2">
                        <Button variant="contained" color="secondary" onClick={resetFilters}>Reset</Button>
                    </Col>
                </Row>
                <Row style={{justifyContent: 'space-around', borderBottom: '1px solid #999'}}>
                    <Col className="Ledger--Header" xs="1" style={{position: 'relative', left: '0.7%'}}><Typography variant="detailsDataValue">Date</Typography></Col>
                    <Col className="Ledger--Header" xs="1" style={{position: 'relative', left: '2%'}}><Typography variant="detailsDataValue">Action For</Typography></Col>
                    <Col className="Ledger--Header" xs="3" style={{position: 'relative', left: '2%'}}><Typography variant="detailsDataValue">Notes</Typography></Col>
                    <Col className="Ledger--Header" xs="2" style={{position: 'relative', left: '3%'}}><Typography variant="detailsDataValue">Type</Typography></Col>
                    <Col className="Ledger--Header" xs="2" style={{position: 'relative', left: '2.7%'}}><Typography variant="detailsDataValue">Currency</Typography></Col>
                    <Col className="Ledger--Header PointsColor" xs="1" style={{position: 'relative', left: '3.5%'}}><Typography variant="detailsDataValue">Points Total</Typography></Col>
                    <Col className="Ledger--Header" xs="2" style={{position: 'relative', left: '5%'}}><Typography variant="detailsDataValue">Expiry Date</Typography></Col>
                </Row>
                <Container fluid className="Ledger Ledger--List">
                    { ledgerData && ledgerData.length ? 
                    _.filter(ledgerData, (entry) => {
                        if (currency && (entry.currencyCode !== currency)) { return false; }
                        if (pointTypeFilter && (entry.pointType !== pointTypeFilter)) { return false }
                        return true;
                    }).sort((a, b) => {
                        return new Date(b.createdOn) - new Date(a.createdOn);
                    })
                        .map((loyalty) => {
                            rowCounter++;
                            return (

                                <Row key={loyalty.id} className={rowCounter % 2 ? 'OddRow' : 'EvenRow'} style={{justifyContent: 'space-evenly'}}>
                                    <Col className="Ledger--Detail" xs="1"><Typography variant="detailsDataLabel">{moment(loyalty.createdOn).format('DD MMM YY') || '--'}</Typography></Col>
                                    <Col className="Ledger--Detail" xs="1"><Typography variant="detailsDataLabel">{loyalty.actionFor || '--'}</Typography></Col>
                                    <Col className="Ledger--Detail" xs="3"><Typography variant="detailsDataLabel">{loyalty.notes || '--'}</Typography></Col>
                                    <Col className="Ledger--Detail" xs="2"><Typography variant="detailsDataLabel">{loyalty.pointType || '--'}</Typography></Col>
                                    <Col className="Ledger--Detail" xs="2"><Typography variant="detailsDataLabel">{loyalty.currencyCode || '--'}</Typography></Col>
                                    <Col className="Ledger--Detail PointsColor" xs="1"><Typography variant="detailsDataLabel">{loyalty.points || '--'}</Typography></Col>
                                    <Col className="Ledger--Detail" xs="1"><Typography variant="detailsDataLabel">{loyalty.expiryDate || '--'}</Typography></Col>
                                </Row>
                            )
                        })
                    : (<div className="Ledger--Detail">No Records</div>)}
                </Container>
            </Container>
        </div>
    );
}


function CurrencySelector({ onCurrencySelected, currency }) {
    return (
        <Form.Select aria-label="Currency Filter" value={currency} onChange={(e) => onCurrencySelected(e.target.value)} style={{fontFamily: siteTheme.typography.fontFamily, fontSize: siteTheme.typography.fontSize, color: siteTheme.palette.primary, fontWeight: siteTheme.typography.fontWeightRegular}}>
            <option value="" style={{fontFamily: siteTheme.typography.fontFamily, fontSize: siteTheme.typography.fontSize, color: siteTheme.palette.primary, fontWeight: siteTheme.typography.fontWeightRegular}}>--</option>
            <option value="AUD" style={{fontFamily: siteTheme.typography.fontFamily, fontSize: siteTheme.typography.fontSize, color: siteTheme.palette.primary, fontWeight: siteTheme.typography.fontWeightRegular}}>AUD</option>
            <option value="GBP" style={{fontFamily: siteTheme.typography.fontFamily, fontSize: siteTheme.typography.fontSize, color: siteTheme.palette.primary, fontWeight: siteTheme.typography.fontWeightRegular}}>GBP</option>
            <option value="USD" style={{fontFamily: siteTheme.typography.fontFamily, fontSize: siteTheme.typography.fontSize, color: siteTheme.palette.primary, fontWeight: siteTheme.typography.fontWeightRegular}}>USD</option>
            <option value="CAD" style={{fontFamily: siteTheme.typography.fontFamily, fontSize: siteTheme.typography.fontSize, color: siteTheme.palette.primary, fontWeight: siteTheme.typography.fontWeightRegular}}>CAD</option>
            <option value="NZD" style={{fontFamily: siteTheme.typography.fontFamily, fontSize: siteTheme.typography.fontSize, color: siteTheme.palette.primary, fontWeight: siteTheme.typography.fontWeightRegular}}>NZD</option>
        </Form.Select>

    )
}

const PointsAdjustmentForm = forwardRef((props, ref) => {
    const [adjustmentType, setAdjustmentType] = useState('ADJUST_ADD');
    const record = props.record;
    const [adjustment, setAdjustment] = useState({
        adjustmentType: adjustmentType,
        userId: props.customer.profile.id,
        currencyCode: props.defaultCurrency || 'AUD',
        points: 0,
        grantedFor: '',
        redemptionFor: '',
        notes: '',
    })

    if (record) {
        setAdjustment(Object.assign({}, record));
    }
    function adjustmentTypeChanged(e) {
        setAdjustmentType(e.target.value);
        setAdjustment({ ...adjustment, adjustmentType: e.target.value });
    }

    function currencyChanged(newCurrency) {
        setAdjustment({ ...adjustment, currencyCode: newCurrency });
    }

    function setPointsAmount(val) {
        setAdjustment({ ...adjustment, points: val });
    }

    function setGrantedFor(val) {
        setAdjustment({ ...adjustment, grantedFor: val });
    }

    function setRedemptionFor(val) {
        setAdjustment({ ...adjustment, redemptionFor: val });
    }

    function setNotes(val) {
        setAdjustment({ ...adjustment, notes: val });
    }


    useImperativeHandle(ref,
        () => ({
            getAdjustmentRecord: () => {
                return adjustment;
            }
        })
    );

    return (
        <Form>
            <fieldset>
                <Form.Group as={Row} className="mb-3" onChange={adjustmentTypeChanged}>
                    <Form.Label as="legend" column sm={2}>
                        Adjustment Type
                    </Form.Label>
                    <Col sm={10}>
                        <Form.Check
                            inline
                            type="radio"
                            label="Add Points"
                            name="adjustmentAction"
                            value="ADJUST_ADD"
                            id="ADJUST_ADD"
                            defaultChecked
                        />
                        <Form.Check
                            inline
                            type="radio"
                            label="Redeem Points"
                            name="adjustmentAction"
                            id="ADJUST_REDEEM"
                            value="ADJUST_REDEEM"
                        />
                    </Col>
                </Form.Group>
            </fieldset>


            <Form.Group as={Row} className="mb-3" controlId="frmCurrency">
                <Form.Label column sm={2}>
                    Currency
                </Form.Label>
                <Col sm={10}>
                    <CurrencySelector currency={adjustment.currency} onCurrencySelected={(currency) => currencyChanged(currency)} />
                </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="frmPoints">
                <Form.Label column sm={2}>
                    Points
                </Form.Label>
                <Col sm={10}>
                    <Form.Control type="number" placeholder="0" value={adjustment.pointsAmount} onChange={(e) => setPointsAmount(e.target.value)} />
                </Col>
            </Form.Group>

            {adjustmentType === 'ADJUST_ADD' ? (
                <Form.Group as={Row} className="mb-3" controlId="frmGrantedFor">
                    <Form.Label column sm={2}>
                        Granted For
                    </Form.Label>
                    <Col sm={10}>
                        <Form.Control type="text" placeholder="Experience ID or other reference" value={adjustment.grantedFor} onChange={(e) => setGrantedFor(e.target.value)} />
                    </Col>
                </Form.Group>

            ) : null}

            {adjustmentType === 'ADJUST_REDEEM' ? (
                <Form.Group as={Row} className="mb-3" controlId="frmRedemptionFor">
                    <Form.Label column sm={2}>
                        Redeemed For
                    </Form.Label>
                    <Col sm={10}>
                        <Form.Control type="text" placeholder="" value={adjustment.redemptionFor} onChange={(e) => setRedemptionFor(e.target.value)} />
                    </Col>
                </Form.Group>
            ) : null}


            <Form.Group as={Row} className="mb-3" controlId="frmNotes">
                <Form.Label column sm={2}>
                    Notes
                </Form.Label>
                <Col sm={10}>
                    <Form.Control style={{ height: '100px' }} type="text" as="textarea" placeholder="" value={adjustment.notes} onChange={(e) => setNotes(e.target.value)} />
                </Col>
            </Form.Group>
        </Form>
    )


})

function ConfirmAdjustment({ customer, adjustmentRecord }) {
    return (
        <Container fluid>
            <Row>
                <Col xs="12">Confirm Points Adjustment</Col>
            </Row>
            <Row>
                <Col xs="4">Action</Col>
                <Col xs="1">:</Col>
                <Col xs="7">{adjustmentRecord.adjustmentType === 'ADJUST_ADD' ? 'Add Points' : 'Redeem Points'}</Col>
            </Row>
            <Row>
                <Col xs="4">Points</Col>
                <Col xs="1">:</Col>
                <Col xs="7">{adjustmentRecord.currencyCode} {adjustmentRecord.points}</Col>
            </Row>
            <Row>
                <Col xs="4">Action For</Col>
                <Col xs="1">:</Col>
                <Col xs="7">{adjustmentRecord.adjustmentType === 'ADJUST_ADD' ? adjustmentRecord.grantedFor : adjustmentRecord.redemptionFor}</Col>
            </Row>
            <Row>
                <Col xs="4">Notes</Col>
                <Col xs="1">:</Col>
                <Col xs="6">{adjustmentRecord.notes}</Col>
            </Row>
        </Container>
    )
}

export default Ledger;
